import * as React from 'react';
import { BuildersInfo } from '../../components/BuildersInfo';
import { getBuilders, getSellers, getIsLeadFactory, getNewbuildingId } from '../../selectors/newbuilding';
import { useSelector } from 'react-redux';
import { trackContactBlockShow } from './tracking';

export const BuildersInfoContainer = () => {
  const builders = useSelector(getBuilders);
  const sellers = useSelector(getSellers);
  const isLeadFactory = useSelector(getIsLeadFactory);
  const newbuildingId = useSelector(getNewbuildingId);

  const agentShowHandler = React.useCallback(() => {
    trackContactBlockShow(newbuildingId, 'agents');
  }, [newbuildingId]);

  const buildersShowHandler = React.useCallback(() => {
    trackContactBlockShow(newbuildingId, 'builders');
  }, [newbuildingId]);

  return (
    <BuildersInfo
      builders={builders}
      sellers={sellers}
      isLeadFactory={isLeadFactory}
      agentsShowHandler={agentShowHandler}
      buildersShowHandler={buildersShowHandler}
    />
  );
};
